export default __webpack_public_path__ + "static/media/pic13.7f3931cf.jpg";